import { CompanyConfiguration, User } from '@gloat/types';

const useIsCareerGrowthAvailable = ({ user, companyConfig }: { user?: User; companyConfig?: CompanyConfiguration }) => {
  const isActionPlanOn = companyConfig?.actionPlan?.isOn;
  const isCareerInsightsOn = companyConfig?.careerInsights?.isOn;
  const { hasCareerTracksAccess, hasCareerPathAccess } = user?.imob?.access || {};
  const canAccessCareerPaths = isCareerInsightsOn && hasCareerPathAccess;
  const canAccessActionPlan = isCareerInsightsOn && isActionPlanOn && hasCareerTracksAccess;
  const canAccessSkillsLandscape =
    companyConfig?.careerDevelopmentCategories?.includes?.('skills-gap') && user?.imob?.access?.canAccessSkillsGap;

  return canAccessCareerPaths || canAccessActionPlan || canAccessSkillsLandscape;
};

export { useIsCareerGrowthAvailable };
